import React from "react";
import { Layout } from "antd";

const { Footer: AntFooter } = Layout;

const Footer: React.FC = () => {
  return (
    <AntFooter
      style={{
        backgroundColor: "#FFF",
        textAlign: "center",
        padding: "34px 10px",
        color: "#777",
        fontFamily: "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
        fontSize: "14px",
        fontWeight: 400,
        letterSpacing: "0.5px",
        lineHeight: 1,
        borderTop: "1px solid #CCC",
        marginTop: "37px",
      }}
    >
      City of New Orleans 2024
    </AntFooter>
  );
};

export default Footer;
